import React, { useEffect } from 'react';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import ClaimStepNavigationWrapper from '../../../../components/ClaimFormComponents/ClaimStepNavigationWrapper';
import useDeviceResize from '../../../../hooks/useDeviceResize';
import { TRANSFER_TYPES_WITHOUT_CASH } from '../../../../constants';
import BankAccountForm from '../../../../components/FormComponents/BankAccountForm/BankAccountForm';
import { getBanks } from '../../../../redux/modules/claimApplication';
import compensationSchema from '../../../../validations/claimValidationSchema/casco/compensationSchema';
import { updateCascoForm } from '../../../../redux/modules/cascoClaim';

import styles from '../../../CompensationContainer/Steps/steps.module.scss';

const CascoCompensationStep = ({
  step,
  goNext,
  goPrevious,
  params: { setStepNavigationBox, scrollTo },
}) => {
  const dispatch = useDispatch();

  const isDeviceLgSize = useDeviceResize('lg');
  const { compensation } = useSelector((store) => store.cascoClaim, shallowEqual);
  const initialData = compensation || {};
  const banks = useSelector((state) => state.claimApplication.banks);
  const { handleSubmit, register, unregister, setValue, errors, clearError } = useForm({
    mode: 'onBlur',
    validationSchema: compensationSchema,
    defaultValues: {
      ...initialData,
    },
  });

  useEffect(() => {
    dispatch(getBanks());
  }, [dispatch]);

  const onSubmit = (data) => {
    dispatch(updateCascoForm({ name: 'compensation', data }));
    goNext(step);
  };

  return (
    <div ref={scrollTo} className={styles.formContainer}>
      <ClaimStepNavigationWrapper
        clearError={clearError}
        errors={errors}
        isNextDisabled={false}
        handleSubmit={handleSubmit}
        setStepNavigationBox={setStepNavigationBox}
        isDeviceLgSize={isDeviceLgSize}
        onSubmit={onSubmit}
        back={goPrevious}
        dependencies={[JSON.stringify(errors), isDeviceLgSize, false]}
      />
      <BankAccountForm
        formProps={{
          register,
          setValue,
          clearError,
          errors,
          unregister,
        }}
        transferTypes={TRANSFER_TYPES_WITHOUT_CASH}
        banks={banks}
        initialData={initialData}
      />
    </div>
  );
};

CascoCompensationStep.propTypes = {
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
    scrollTo: PropTypes.func.isRequired,
    formLanguage: PropTypes.string,
  }).isRequired,
  step: PropTypes.shape({
    n: PropTypes.number.isRequired,
  }).isRequired,
  goNext: PropTypes.func.isRequired,
  goPrevious: PropTypes.func.isRequired,
};

export default CascoCompensationStep;
